export default {
  meta: {
    title: '登录',
    urlName: '登录' // 埋点字段，上报归属的模块
  }
};
